export const agendaConstants = {
    GETAGENDA_REQUEST: 'GET_AGENDA_REQUEST',
};
